import React from 'react';
import {Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid} from '@material-ui/core'
import Utils from '../../providers/Utils';



 

export default class Ponteaza extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
     
         }
    }

     componentDidMount(){
  
    }

   
     render() { 
       return (
          <div>
               <Dialog 
                 className="pm-alert-dialog"
                disableEscapeKeyDown
                fullWidth={true}
                maxWidth='sm'
                 open={this.props.open}
                 onClose={this.props.dialogClose}>
                 <DialogActions >
                 <Fab  onClick={this.props.dialogClose} className="pm-round-button-dialog">
                                      <i className='material-icons pm-round-button-text-dialog'>close</i>
                            </Fab>
                 </DialogActions>
                 <h2 style={{marginBottom:0}} className='pm-title'>{this.props.title}</h2>
                 <h3 style={{marginBottom:0}} className='pm-title'>{new Utils().dataAzi()}</h3>
                 <h4 style={{marginTop:0,color:'#5a0be8'}} className='pm-title'>Timp Lucru: {this.props.timer}</h4>

                    <Grid  container  className="container pm-dialog-textfield-container" >
      
               
                            <Grid style={{textAlign:'center'}} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    id="with-placeholder"
                                    label={'Start Pontaj'}
                                    name={'nrOraInceput'}
                                    disabled={this.props.status !== 'Started' ? false : true}
                                    margin="normal"
                                    type='time'
                                    value={this.props.nrOraInceput || ''}
                                    onChange={this.props.handleChange}
                                />
                            </Grid>
                
                {this.props.status !== null && 
                    <Grid style={{textAlign:'center'}} item xs={12} sm={12} md={12} lg={12} xl={12} >
                    <TextField
                        className="inputFocus loginTextField"
                        id="with-placeholder"
                        name={'nrOraSfarsit'}
                        label={'Sfarsit Pontaj'}
                        margin="normal"
                        type='time'
                        value={this.props.nrOraSfarsit || ''}
                        onChange={this.props.handleChange}
                    />
                </Grid>
                }
                            
                    </Grid>        

                 <DialogActions className="pm-dialog-bottom-buttons">
                          
                          <Button  variant="outlined" onClick={this.props.addPontaj} className='pm-save-button'>
                                      {this.props.status !== null ? 'Sfarsit Pontaj' : 'Start Pontaj'}
                          </Button>

                         
                          
                       
                      </DialogActions>
                       
                   
                 </Dialog>
         </div>
        );
       }
}